<template>
  <div>
    <section id="faq-tabs">
      <b-overlay
        :show="loader.pagina"
        opacity="0.50"
        rounded="sm"
      >
        <b-tabs
          vertical
          content-class="col-12 col-md-8 col-lg-9"
          pills
          nav-wrapper-class="faq-navigation col-md-4 col-lg-3 col-12"
          nav-class="nav-left"
        >
          <b-tab
            v-for="preguntas in faqData"
            :key="preguntas.tabs.id"
          >
            <template #title>
              <feather-icon
                :icon="preguntas.tabs.icon"
                size="18"
                class="mr-1"
              />
              <span class="font-weight-bold">{{ preguntas.tabs.tabname }} </span>
            </template>
            <faq-question-answer :options="preguntas" />
          </b-tab>
          <template #tabs-end>
            <b-img
              fluid
              :src="require('@/assets/images/illustration/ayuda-indetec.svg')"
              class="d-none d-md-block mt-auto"
              width="100"
              alt="Ayuda Indetec Campus virtual"
            />
          </template>
        </b-tabs>
      </b-overlay>
    </section>
    <section class="faq-contact">
      <b-row class="mt-5 pt-75 text-center">
        <b-col cols="12">
          <h2>¿Todavía tienes una pregunta?</h2>
          <b-card-text class="mb-3">
            Si no puede encontrar una pregunta en nuestras preguntas frecuentes, siempre puede contactarnos.
          </b-card-text>
        </b-col>
        <b-col sm="6">
          <b-card
            class="shadow-none py-1 faq-contact-card"
          >
            <b-avatar
              size="42"
              rounded
              variant="light-primary"
              class="mb-2"
            >
              <feather-icon
                icon="PhoneCallIcon"
                size="18"
              />
            </b-avatar>
            <h4>3336695550 al 5559 ext: 311</h4>
            <span class="text-body">Siempre estamos felices de ayudar!</span>
          </b-card>
        </b-col>
        <b-col sm="6">
          <b-card
            class="shadow-none py-1 faq-contact-card"
          >
            <b-link :to="{ path: 'contacto' }">
              <b-avatar
                size="42"
                rounded
                variant="light-primary"
                class="mb-2"
              >
                <feather-icon
                  icon="MailIcon"
                  size="18"
                />
              </b-avatar>
              <h4>Soporte</h4>
              <span class="text-body">Asistencia vía correo electrónico.</span>
            </b-link>
          </b-card>
        </b-col>
      </b-row>
    </section>
  </div>
</template>

<script>
import {
  BCard, BCardText, BTabs, BTab, BImg, BRow, BCol, BAvatar, BLink, BOverlay,
} from 'bootstrap-vue'
import { getData } from '@core/utils/http/general'
import FaqQuestionAnswer from './FaqQuestionAnswer.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BAvatar,
    BLink,
    BCardText,
    BTabs,
    BTab,
    BImg,
    BOverlay,
    FaqQuestionAnswer,
  },
  data() {
    return {
      faqData: [],
      loader: {
        pagina: false,
      },
    }
  },
  created() {
    this.get_data()
  },
  methods: {
    get_data() {
      this.loader.pagina = true
      getData({ action: 1 }, 'wspagepublic')
        .then(response => {
          if (response.status === 200 || response.data.status === 200) {
            this.faqData = response.data.data
          } else {
            this.$bvToast.toast(response.data.message, {
              title: `${response.data.status} - Sección en construcción`,
              variant: 'danger',
              solid: true,
            })
          }
          this.loader.pagina = false
        }).catch(err => {
          this.loader.pagina = false
          this.$bvToast.toast(err, {
            title: 'Error, No hay conexión',
            variant: 'danger',
            solid: true,
          })
        })
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/pages/page-faq.scss';
</style>
